// extracted by mini-css-extract-plugin
export default {"button":"xvN0H","container":"TOo6J","loader":"F5yiV"};